var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTelegram18Dp = function SvgTelegram18Dp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4987 2.78786L2.2012 7.91561C1.2937 8.28011 1.29895 8.78636 2.0347 9.01211L5.4487 10.0771L13.3477 5.09336C13.7212 4.86611 14.0625 4.98836 13.782 5.23736L7.3822 11.0131H7.3807L7.3822 11.0139L7.1467 14.5329C7.4917 14.5329 7.64395 14.3746 7.83745 14.1879L9.4957 12.5754L12.945 15.1231C13.581 15.4734 14.0377 15.2934 14.196 14.5344L16.4602 3.86336C16.692 2.93411 16.1055 2.51336 15.4987 2.78786Z",
    fill: "currentColor"
  })));
};

export { SvgTelegram18Dp as ReactComponent };
export default __webpack_public_path__ + "d506d13c34bb14177c520da3781992e3.svg";